import * as React from 'react';

const SubPageTitle = ({title}) => {
    return (
        <div className="text-center my-4 py-4 bg-primary text-white">
            <h1>{title}</h1>
        </div>
    )
}
export default SubPageTitle